import axios from 'axios'
import { publicPageRequest } from '../utils/request'
import {
  GET_CAPTCHA_API,
  GOOGLE_REGISTRATION_AUTH_API,
  GOOGLE_REGISTRATION_AUTH_URL_API,
  LOGIN_API,
  LOGIN_TWO_FACTOR_AUTH_API,
  REGISTER_CONFIRM_API,
  RESET_PASSWORD_API,
  SEND_RESET_API,
  SIGN_UP_API,
} from './constants'
import type {
  GoogleRegistrationAuthPayloadInterface,
  GoogleRegistrationAuthResponseInterface,
  GoogleRegistrationAuthUrlResponseInterface,
  LoginFormInterface,
  RegisterConfirmApiInterface,
  ResetPasswordInterface,
  SendResetFormInterface,
  TwoFactorAuthFormInterface,
} from './types'

export const twoFactorAuth = ({
  authCode,
  trusted,
}: TwoFactorAuthFormInterface) => {
  return publicPageRequest.post<{ redirect: string }>(
    LOGIN_TWO_FACTOR_AUTH_API,
    {
      _auth_code: authCode,
      _trusted: trusted,
    },
  )
}
export const signUp = (email: string) => {
  return publicPageRequest.post<{ redirect: string }>(SIGN_UP_API, { email })
}

export const login = ({ rememberMe, ...body }: LoginFormInterface) => {
  return publicPageRequest.post<{ redirect: string }>(LOGIN_API, {
    ...body,
    _remember_me: rememberMe,
  })
}

export const sendReset = ({ email, captcha }: SendResetFormInterface) => {
  return publicPageRequest.post<{ redirect?: string }>(SEND_RESET_API, {
    email,
    captcha,
  })
}

export const resetPassword = ({ password, token }: ResetPasswordInterface) => {
  return publicPageRequest.post<{ redirect?: string }>(RESET_PASSWORD_API, {
    password,
    token,
  })
}

export const registerConfirm = (body: RegisterConfirmApiInterface) => {
  return publicPageRequest.post<{ redirect?: string }>(
    REGISTER_CONFIRM_API,
    body,
  )
}

export const getCaptcha = () => {
  return publicPageRequest.get<{ openKey: string }>(GET_CAPTCHA_API)
}

export const getGoogleRegistrationAuthUrl = () => {
  return axios.get<GoogleRegistrationAuthUrlResponseInterface>(
    GOOGLE_REGISTRATION_AUTH_URL_API,
  )
}

export const googleRegistrationAuth = (
  payload: GoogleRegistrationAuthPayloadInterface,
) => {
  return axios.post<GoogleRegistrationAuthResponseInterface>(
    GOOGLE_REGISTRATION_AUTH_API,
    null,
    {
      params: payload,
    },
  )
}
